if (!/electron/.test(window.location.href)) {
    /**
     * How many times script to readjust onload.
     */
    const timesToadjust = 3;

    /**
     * Height to add.
     */
    const heightToAdd = 80;

    /**
     * After window resources loaded.
     */
    window.onload = () => {
        sendGameHeight();
        let i = 0;
        let autoResize = setInterval(() => {
            if (i == timesToadjust) {
                clearInterval(autoResize);
                i = 0;
            } else {
                sendGameHeight();
                i ++ ;
            }
        }, 1000)
    }

    /**
     * Setting iframe element on recieved iframe event (on iframe resize).
     */
    window.onmessage = (event) =>
    {
        if (event.data.eventName == 'iframe_to_game') {
            sendGameHeight();
        }
    }

    /**
     * Checks is game in iframe.
     */
    function inIframe () {
        try {
            return window.self !== window.top;
        } catch (e) {
            return true;
        }
    }

    /**
     * Send game scroll height to parent window (iframe)
     */
    function sendGameHeight() {
        const body = document.body,
        html = document.documentElement;
        if (inIframe()) {
            window.parent.postMessage({
                eventName: 'game_to_iframe',
                response: Number(document.body.scrollHeight) + heightToAdd
            }, '*');
        }
    }   
}



//////////////////
// WEBPACK FOOTER
// ./src/ui/js/iframe-script.js
// module id = 47
// module chunks = 13